import * as auth from '../actions/auth';

const initialState = {
  isFetching: false,
  token: undefined,
  user: undefined,
  passwordResetToken: null,
  loginMfaRequired: false,
  pendingMfaUsername: undefined,
  mfaError: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case auth.LOGIN_SUCCESS:
    case auth.SIGNUP_SUCCESS:
      return {
        isFetching: false,
        token: action.payload.token,
        user: action.payload.user,
        loginMfaRequired: false,
        pendingMfaUsername: undefined,
        mfaError: '',
      };
    case auth.LOGIN_MFA_REQUIRED:
      return {
        ...state,
        isFetching: false,
        loginMfaRequired: true,
        pendingMfaUsername: action.payload.username,
        mfaError: '',
      };
    case auth.LOGIN_MFA_FAILURE:
      return {
        ...state,
        isFetching: false,
        mfaError: 'Invalid authentication code.',
      };
    case auth.RESET_LOGIN_MFA:
      return {
        ...state,
        loginMfaRequired: false,
        pendingMfaUsername: undefined,
        mfaError: '',
      };
    case auth.GET_USER_INFO_REQUEST:
    case auth.GET_ALL_USERS_REQUEST:
    case auth.SIGNUP_REQUEST:
    case auth.LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
      };

    case auth.GET_USER_INFO_SUCCESS:
      return {
        ...state,
        isFetching: false,
        user: action.payload,
      };
    case auth.GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        userList: action.payload,
      };

    case auth.LOGIN_FAILURE:
    case auth.LOGOUT:
    case auth.SIGNUP_FAILURE:
      return initialState;

    case auth.LOGIN_RESET_PASSWORD:
      return {
        ...initialState,
        passwordResetToken: action.payload.reset_token,
      };

    default:
      return state;
  }
};
